import { useTranslation } from "@sagot/i18n";
import { Button, Icon, toast } from "@sagot/ui";
import type { LeadDetail } from "./lead-types";
import { useRegenerateSummary } from "./use-leads";

/** "Conversation summary · generated by AI" box (`POST /v1/leads/{id}/summary?refresh=true`). */
export function LeadSummary({ lead, canEdit }: { lead: LeadDetail; canEdit: boolean }) {
  const { t } = useTranslation();
  const regenerate = useRegenerateSummary(lead.id);
  const onRegenerate = () => {
    regenerate.mutate(undefined, {
      onError: () => {
        toast.error(t("engage.leads.sheet.summaryFailed"));
      },
    });
  };
  return (
    <section className="rounded-lg border border-line bg-primary-soft p-4" aria-labelledby="lead-summary-title" aria-busy={regenerate.isPending}>
      <div className="flex items-center justify-between gap-2">
        <h3 id="lead-summary-title" className="flex items-center gap-1.5 text-xs font-bold text-primary-ink">
          <Icon name="sparkles" className="size-3.5" />
          {t("engage.leads.sheet.summaryTitle")}
        </h3>
        {canEdit ? (
          <Button variant="ghost" size="sm" loading={regenerate.isPending} onClick={onRegenerate}>
            <Icon name="refresh-cw" />
            {t("engage.leads.sheet.regenerate")}
          </Button>
        ) : null}
      </div>
      <p className="mt-2 text-sm leading-relaxed text-fg">
        {lead.ai_summary ?? t("engage.leads.sheet.noSummary")}
        {lead.intent ? <strong> {t("engage.leads.sheet.intent", { intent: lead.intent })}</strong> : null}
        {lead.suggested_next_step ? <> {t("engage.leads.sheet.nextStep", { step: lead.suggested_next_step })}</> : null}
      </p>
    </section>
  );
}
